import { useCallback, useRef } from 'react'
import { app } from 'config'
import { analytics } from 'config/segment'
import isEqual from 'lodash/isEqual'
import { getDeviceForTracking } from 'utils/analytics'
import { getStoredAttributionProperties, getStoredUtmCampaignOptions } from './utmCampaignContext'

export const usePageTracking = () => {
  const currentPage = useRef('')
  const currentAttributes = useRef({})

  const trackPage = useCallback(
    (nextPage: string, pageAttributes?: Record<string, string | number | boolean>) => {
      // remove trailing slash
      const normalizedPage = nextPage.replace(/\/$/, '')

      if (
        currentPage.current === normalizedPage &&
        isEqual(currentAttributes.current, pageAttributes || {})
      ) {
        return
      }

      const attributionProperties = getStoredAttributionProperties()
      const allProperties = {
        ...attributionProperties,
        ...pageAttributes,
        $device: getDeviceForTracking()
      }
      const options = getStoredUtmCampaignOptions()

      currentPage.current = normalizedPage
      currentAttributes.current = pageAttributes || {}
      analytics.page(normalizedPage, allProperties, options)

      if (!app.analyticsEnabled) {
        // eslint-disable-next-line no-console
        console.debug('trackPage', normalizedPage, allProperties)
      }
    },
    []
  )

  return trackPage
}
